import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  container: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    padding: "16px",
    background: theme.palette.background.paper,
    borderRadius: "12px",
  },
  receiptDetails: {
    fontWeight: "500",
    fontSize: "16px",
    color: theme.palette.text.primary,
  },
  netAmount: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  paymentMode: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  emptyState: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  contentWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    width: "100%",
  },
  title: {
    fontWeight: "600",
    fontSize: "18px",
    color: theme.palette.text.primary,
    paddingBottom: "4px",
  },
}));
